import { useMemo } from 'react'

import { doUnlinkJiraServerIssue } from 'ducks/integrations/jiraServer'
import { useAction } from 'util/hooks'

export function useJiraServerIssueActions(issue, doCloseIssueView) {
  const { externalId, url } = issue || {}
  const onUnlink = useAction(doUnlinkJiraServerIssue)
  return useMemo(
    () => {
      if (!externalId) return []
      return [
        {
          action: () => {
            onUnlink(externalId)
            doCloseIssueView()
          },
          text: 'Unlink',
        },
        {
          blankTarget: true,
          text: ['Open on Jira'],
          url,
        },
      ]
    },
    [doCloseIssueView, externalId, onUnlink, url]
  )
}
